// src/com/sms_sent/SmsSentListOverCust.js
import React, { useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import FlexyTable from '../common/flexytable/FlexyTable';
import { ContentHeader, HeaderLeft } from '../common/CvoStyled';
import SearchBox from '../common/SearchBox';
import { TableColumnType } from '../../model/AppConst';

const CustListContainer = styled(Box)({
    flexGrow:1,
    display: 'flex', flexDirection: 'column', // backgroundColor: 'orange',
});

const CustTitle = styled(Box)({
    fontWeight: 'bold', marginRight: 10,
})

const TableColumns = [
    { id: 'custId', label: '업체ID', width: 100, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    { id: 'tranDate', label: '날짜', width: 100, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    { id: 'tranPhone', label: '수신번호', width: 120, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    { id: 'callBack', label: '발신번호', width: 120, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    { id: 'tranId', label: '이름 또는 ID', width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    // { id: 'etc3', label: '기타', width: 100, show: true, option:{align: 'center', type: TableColumnType.TEXT} },
    // 전송내용이 잘리지 않도록 넓게. 그래도 넘치는 긴 문자는 마우스를 올리면 전체 내용이 보임.
    { id: 'message', label: '전송내용', width: 1400, show: true, option:{align: 'inherit', print: (r,i,v)=>{
        const text = (v || '').replace(/[\r\n]+/g, ' ');
        return <span title={text}>{text}</span>;
    }} },
];

export default function SmsSentListOverCust({
    date,
    records,
    itemCust,
}) {
    const [search, setSearch] = useState('');

    const onChangeSearch = (text) => {
        setSearch(text);
    };

    const renderCustomer = () => {
        if(itemCust) {
            return(
                <CustTitle>
                    {itemCust.custName} ({itemCust.custId}), {date}부터 1개월간 모든 SMS 송신 기록
                </CustTitle>
            );
        }
        return <CustTitle>업체를 선택하세요</CustTitle>
    };

    return(
        <CustListContainer>
            <ContentHeader>
                <HeaderLeft>
                    {renderCustomer()}
                    <SearchBox
                        value={search}
                        onChange={onChangeSearch}
                        disabled={records.length === 0}
                    />
                </HeaderLeft>
            </ContentHeader>
            <FlexyTable
                name="sms_sent_list_over_cust"
                uniqueKey="sentId"
                columns={TableColumns}
                records={records}
                search={search}
            />
        </CustListContainer>
    );
}

// 5450 2032 658.
